import usePrivateLink from "../../../config/usePrivateLink";
import React, { useEffect, useRef, useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";

import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  closeModal,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../../../master/Master";
import { excelimport } from "../../../../api/MarketinService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../v2/TestReportPrint.css";
import TestLayout from ".././TestLayout";
import Nav from "../../../master/NavBar";
import Footer from "../../footer";
import Header from "../../../master/SideBar";
import {
  getTestDetails,
  obtendMarks,
  removeTestSubjects,
  testLock,
} from "../../../../api/TestServiceV2";
import { testMessage, testUnLock } from "../../../../api/TestService";
import Swal from "sweetalert2";
export default function Testreport() {
  const hasAccess = usePrivateLink();
  const location = useLocation();
  // const id = location?.state?.id;
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);
  const [responseMsg, setResponseMsg] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [testData, setTestData] = useState("");
  const [search, setSearch] = useState("");

  // this data is dummy
  const [selectedFile, setSelectedFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [rowErrors, setRowErrors] = useState({});
  const [statuses, setStatuses] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [delay, setDelay] = useState(1000);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedTest, setSelectedTest] = useState("");
  const intervalRef = useRef(null);
  const [error, setError] = useState("");

  const [showMissingSubjectsModal, setShowMissingSubjectsModal] =
    useState(false);
  const [selectedRemoveSubjects, setSelectedRemoveSubjects] = useState([]);
  const [removingSubjects, setRemovingSubjects] = useState(false);

  const getMissingSubjects = () => {
    if (
      details?.exam_mode === "combined" ||
      !details?.subject_details?.length ||
      !details?.marks?.length
    ) {
      return [];
    }

    const subjects = details.subject_details;

    return subjects.filter((subject) => {
      const subjectId = String(subject?.subject_id);

      // Check whether at least ONE student has marks for this subject
      const hasMarksForAnyStudent = details.marks.some((student) => {
        if (student?.is_absent === "1") {
          return false;
        }

        const studentSubjects =
          student?.student_subjects?.length > 0
            ? student.student_subjects
            : subjects;

        const subjectIndex = studentSubjects.findIndex(
          (s) => String(s?.subject_id) === subjectId,
        );

        if (subjectIndex === -1) {
          return false;
        }

        const obtainedMarks = getObtainedMarks(student);

        const marks = obtainedMarks[subjectIndex];
        if (
          marks === null ||
          marks === undefined ||
          String(marks).trim() === ""
        ) {
          return false;
        }
        if (String(marks).trim().toUpperCase() === "A") {
          return false;
        }

        return true;
      });
      return !hasMarksForAnyStudent;
    });
  };

  const toggleRemoveSubject = (subjectId) => {
    const id = String(subjectId);

    setSelectedRemoveSubjects((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }

      return [...prev, id];
    });
  };

  const handleRemoveSubjects = async () => {
    if (!selectedRemoveSubjects.length) {
      SweetAlertShow(
        "info",
        "Select Subject",
        "Please select at least one subject to remove.",
      );
      return;
    }

    const result = await Swal.fire({
      title: "Remove Subjects?",
      text: `${selectedRemoveSubjects.length} subject(s) will be removed from this test.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Remove",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    setRemovingSubjects(true);

    try {
      const response = await removeTestSubjects({
        test_id: details?.id,
        subject_ids: selectedRemoveSubjects,
      });

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Subjects removed successfully!",
        });

        setSelectedRemoveSubjects([]);

        await fetchDetails();
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to remove subjects.",
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setRemovingSubjects(false);
    }
  };

  const handleFileChange = (e) => {
    alert("handleFileChange called");
    console.log("File Selected", e.target.files);

    const file = e.target.files[0];
    setSelectedFile(file);

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet);

      setExcelData(rows);
      setStatuses(Array(rows.length).fill("pending"));
      setCurrentIndex(0);
    };
    reader.readAsBinaryString(file);
  };

  const updateStatus = (index, status) => {
    setStatuses((prev) => {
      const newStatuses = [...prev];
      newStatuses[index] = status;
      return newStatuses;
    });
  };

  // UploadRow me Excel course_id ko override karo
  const uploadRow = async (index) => {
    const row = { ...excelData[index] };

    // agar course select kiya hai to excel ka id ignore karke ye lagao
    if (selectedTest) {
      row.test_id = selectedTest;
    }

    const formData = new FormData();
    Object.entries(row).forEach(([key, val]) =>
      formData.append(key, val ?? ""),
    );

    try {
      const res = await obtendMarks(formData);

      if (res.status === false && res.errors) {
        updateStatus(index, "failed");
        setRowErrors((prev) => ({
          ...prev,
          [index]: res.errors,
        }));
        return;
      }

      updateStatus(index, "success");
    } catch (error) {
      console.error(`Upload failed for row ${index}`, error);
      updateStatus(index, "failed");

      if (error.response?.data?.errors) {
        setRowErrors((prev) => ({
          ...prev,
          [index]: error.response.data.errors,
        }));
      }
    }
  };

  const handleUpload = async () => {
    if (!excelData.length) return alert("No data");

    // setLoading(true);

    const processRow = async (index) => {
      if (index >= excelData.length) {
        setLoading(false);
        return;
      }

      if (statuses[index] === "pending") {
        await uploadRow(index);
        // delay between calls
        await new Promise((res) => setTimeout(res, delay));
      }

      if (statuses[index] === "failed") {
        // Stop loop on failure
        setCurrentIndex(index);
        // setLoading(false);
        return;
      }

      setCurrentIndex(index + 1);
      await processRow(index + 1);
    };

    processRow(currentIndex);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => prev + 1);
    handleUpload();
  };

  const handleRepair = (index) => {
    updateStatus(index, "pending");
    setRowErrors((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
    setCurrentIndex(index);
    handleUpload();
  };

  const countStatus = (type) =>
    statuses.filter((status) => status === type).length;

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const response = await getTestDetails(id);
      console.log("test response ", response);

      console.log("API DATA :", response.data.data);

      if (response.data.status) {
        setDetails(response?.data?.data);
        setTestData(response?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const TestMarksObtend = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await obtendMarks(formData);
      // console.log('api chali 1', response)
      if (response?.data?.status) {
        // console.log('api chali 2', response)

        ToastMain.fire({
          icon: "success",
          title: "update Successfully!",
        });
        // fetchDetails();
        console.log("api chali 3", response);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    }
  };

  const TestLocked = async () => {
    setLoading(true);
    try {
      const response = await testLock(id);
      if (response?.data?.status) {
        fetchDetails();
        ToastMain.fire({
          icon: "success",
          title: "update Successfully!",
        });
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });
      SweetAlertShow(
        "error",
        "Warning",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const TestLockedMessage = async (id) => {
    // alert('id 1',id)
    setLoading(true);
    try {
      const response = await testMessage(id);
      // alert('id 2',id)
      if (response?.data?.status) {
        fetchDetails();
        ToastMain.fire({
          icon: "success",
          title: "update Successfully!",
        });
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong',
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const TestUnLocked = async (id) => {
    setLoading(true);
    try {
      const response = await testUnLock(id);
      if (response?.data?.status) {
        fetchDetails();
        ToastMain.fire({
          icon: "success",
          title: "update Successfully!",
        });
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // const TestPresnetAbsent = async (e) => {

  //   e.preventDefault();

  //   try {
  //     const formData = new FormData(e.target);
  //     const response = await AbsentPresnt(formData);
  //     if (response?.data?.status) {
  //       ToastMain.fire({
  //         icon: "success",
  //         title: "update Successfully!",
  //       });
  //       fetchDetails(id);
  //     } else {
  //       // ToastMain.fire({
  //       //   icon: "info",
  //       //   title: response?.data?.message || "Something Want Wrong!",
  //       // });

  //       SweetAlertShow('info','Warning',response?.data?.message )
  //     }
  //   } catch (error) {
  //     // ToastMain.fire({
  //     //   icon: "error",
  //     //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
  //     // });
  //     SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
  //   }
  // };

  useEffect(() => {
    fetchDetails(id);
  }, []);
  const navigate = useNavigate();
  const getGrade = (percentage) => {
    if (percentage >= 90) return "A+";
    if (percentage >= 80) return "A";
    if (percentage >= 70) return "B+";
    if (percentage >= 60) return "B";
    if (percentage >= 50) return "C+";
    if (percentage >= 40) return "C";
    if (percentage >= 33) return "D";
    return "F";
  };

  const getResult = (percentage) => {
    return percentage >= 33 ? "Pass" : "Fail";
  };
  const handleDownload = () => {
    const exportData = details?.marks || [];

    if (!Array.isArray(exportData) || exportData.length === 0) {
      ToastMain.fire({
        icon: "info",
        title: "No marks data available to export",
      });
      return;
    }

    try {
      let transformedData = [];

      /*
       * =====================================================
       * COMBINED EXAM
       * =====================================================
       */

      if (details?.exam_mode === "combined") {
        transformedData = exportData.map((item) => {
          const maximumMarks = Number(details?.combined_marks || 0);

          const isAbsent = item?.is_absent === "1";

          const obtainedMarks = isAbsent
            ? null
            : Number(item?.obtained_total || 0);

          const percentage =
            maximumMarks > 0 && obtainedMarks !== null
              ? (obtainedMarks / maximumMarks) * 100
              : 0;

          return {
            "Student Name": item?.student_details?.name || "-",

            "SR/Registration No.":
              item?.student_details?.registration_no || "-",

            "Father's Name": item?.student_details?.father_name || "-",

            "Combined Marks": isAbsent ? "Absent" : obtainedMarks,

            "Maximum Marks": maximumMarks,

            Percentage: isAbsent ? "-" : `${percentage.toFixed(1)}%`,

            Grade: isAbsent ? "-" : getGrade(percentage),

            Result: isAbsent ? "Absent" : getResult(percentage),
          };
        });
      } else {
        /*
         * =====================================================
         * SUBJECT-WISE EXAM
         * =====================================================
         *
         * One row = One Student
         *
         * Every subject becomes a separate column.
         *
         * Example:
         *
         * English | Hindi | Maths | Science | SST
         *    80   |  75   |  90   |   85    | 88
         *
         * Then:
         *
         * Obtained Marks = 418
         * Maximum Marks  = 500
         * Percentage     = 83.6%
         * Grade          = A
         * Result         = Pass
         *
         * =====================================================
         */
        transformedData = exportData.map((item) => {
          let obtainedMarks = [];

          try {
            const parsedObtainedMarks = JSON.parse(
              item?.obtained_marks || "[]",
            );

            if (Array.isArray(parsedObtainedMarks)) {
              obtainedMarks = parsedObtainedMarks;
            }
          } catch (error) {
            console.error(
              "Invalid obtained_marks JSON:",
              item?.obtained_marks,
              error,
            );
          }

          const subjects =
            item?.student_subjects?.length > 0
              ? item.student_subjects
              : details?.subject_details || [];

          /*
           * -----------------------------------------------
           * STUDENT BASIC INFORMATION
           * -----------------------------------------------
           */

          const row = {
            "Student Name": item?.student_details?.name || "-",

            "SR/Registration No.":
              item?.student_details?.registration_no || "-",

            "Father's Name": item?.student_details?.father_name || "-",
          };

          let totalObtained = 0;
          let totalMaximum = 0;
          let hasFailedSubject = false;
          let isAbsent = item?.is_absent === "1";

          /*
           * -----------------------------------------------
           * SUBJECT COLUMNS
           * -----------------------------------------------
           */

          subjects.forEach((subject, subjectIndex) => {
            const subjectName =
              subject?.subject || `Subject ${subjectIndex + 1}`;

            const maximumMarks = Number(subject?.marks || 0);

            const rawMarks = obtainedMarks[subjectIndex];

            const subjectAbsent =
              isAbsent || String(rawMarks || "").toUpperCase() === "A";

            let obtained = 0;

            if (!subjectAbsent) {
              obtained = Number(rawMarks || 0);

              if (Number.isNaN(obtained)) {
                obtained = 0;
              }
            }

            /*
             * Subject column
             *
             * Example:
             * English = 80
             * Maths   = 90
             */

            row[subjectName] = subjectAbsent ? "Absent" : obtained;

            /*
             * Add to overall total
             */

            totalMaximum += maximumMarks;

            if (!subjectAbsent) {
              totalObtained += obtained;

              /*
               * Check subject-wise passing
               *
               * 33% is considered passing.
               */

              const subjectPercentage =
                maximumMarks > 0 ? (obtained / maximumMarks) * 100 : 0;

              if (subjectPercentage < 33) {
                hasFailedSubject = true;
              }
            }
          });

          /*
           * -----------------------------------------------
           * OVERALL CALCULATION
           * -----------------------------------------------
           */

          const percentage =
            totalMaximum > 0 ? (totalObtained / totalMaximum) * 100 : 0;

          /*
           * -----------------------------------------------
           * TOTAL COLUMNS
           * -----------------------------------------------
           */

          row["Obtained Marks"] = isAbsent ? "Absent" : totalObtained;

          row["Maximum Marks"] = totalMaximum;

          row["Percentage"] = isAbsent ? "-" : `${percentage.toFixed(1)}%`;

          row["Grade"] = isAbsent ? "-" : getGrade(percentage);

          row["Rank"] = isAbsent ? "-" : (item?.rank ?? "-");

          /*
           * Student must pass every subject.
           */

          row["Result"] = isAbsent
            ? "Absent"
            : hasFailedSubject
              ? "Fail"
              : getResult(percentage);

          return row;
        });
      }

      /*
       * =====================================================
       * SAFETY CHECK
       * =====================================================
       */

      if (!transformedData.length) {
        ToastMain.fire({
          icon: "info",
          title: "No data available to export",
        });

        return;
      }

      console.log("Excel Export Data:", transformedData);

      /*
       * =====================================================
       * CREATE WORKSHEET
       * =====================================================
       */

      const worksheet = XLSX.utils.json_to_sheet(transformedData);

      /*
       * =====================================================
       * COLUMN WIDTHS
       * =====================================================
       */

      const columnWidths = [];

      Object.keys(transformedData[0]).forEach((column) => {
        let width = 15;

        if (column === "Student Name") {
          width = 25;
        } else if (column === "SR/Registration No.") {
          width = 20;
        } else if (column === "Father's Name") {
          width = 25;
        } else if (column === "Percentage") {
          width = 14;
        } else if (column === "Obtained Marks" || column === "Maximum Marks") {
          width = 16;
        } else if (column === "Result") {
          width = 12;
        } else if (column === "Grade") {
          width = 10;
        } else {
          /*
           * Subject columns
           */
          width = Math.max(15, Math.min(column.length + 4, 25));
        }

        columnWidths.push({
          wch: width,
        });
      });

      worksheet["!cols"] = columnWidths;

      /*
       * =====================================================
       * CREATE WORKBOOK
       * =====================================================
       */

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Marks Report");

      /*
       * =====================================================
       * DOWNLOAD
       * =====================================================
       */

      XLSX.writeFile(workbook, `Marks_Report_${details?.title || "Test"}.xlsx`);

      ToastMain.fire({
        icon: "success",
        title: "Excel exported successfully!",
      });
    } catch (error) {
      console.error("Excel export error:", error);

      ToastMain.fire({
        icon: "error",
        title: "Excel export failed",
        text: error?.message || "Unable to generate Excel file.",
      });
    }
  };

  const handleExcelUpload = (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) {
      return;
    }

    // Keep the actual file for API upload if required
    setFile(selectedFile);

    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);

        const workbook = XLSX.read(data, {
          type: "array",
        });

        if (!workbook.SheetNames.length) {
          SweetAlertShow(
            "info",
            "Invalid Excel",
            "No worksheet found in the uploaded Excel file.",
          );
          return;
        }

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
          raw: false,
        });

        if (!jsonData.length) {
          SweetAlertShow(
            "info",
            "Empty Excel",
            "The uploaded Excel file does not contain any data rows.",
          );
          return;
        }

        console.log("Excel Data:", jsonData);

        // Show imported data in preview
        setExcelData(jsonData);

        // Reset upload statuses
        setStatuses(Array(jsonData.length).fill("pending"));

        setRowErrors({});
        setCurrentIndex(0);
      } catch (error) {
        console.error("Excel read error:", error);

        SweetAlertShow(
          "error",
          "Excel Error",
          "Unable to read the uploaded Excel file.",
        );
      }
    };

    reader.onerror = () => {
      SweetAlertShow(
        "error",
        "Excel Error",
        "Unable to read the selected file.",
      );
    };

    reader.readAsArrayBuffer(selectedFile);
  };

  const handleAutoFormFill = async (dataFromExcel) => {
    if (!Array.isArray(dataFromExcel) || dataFromExcel.length === 0) {
      SweetAlertShow("info", "No Data", "No records found in the Excel file.");
      return;
    }

    const batchSize = 5;
    const totalRecords = dataFromExcel.length;

    const processBatch = async (batchData) => {
      const batchPromises = batchData.map(async (row) => {
        try {
          const formData = new FormData();

          // Test ID
          formData.append(
            "test_id",
            row.test_id || selectedTest || details?.id || "",
          );

          // Registration number
          formData.append("registration_no", row.registration_no || "");

          if (details?.exam_mode === "combined") {
            formData.append("combined_marks", row.combined_marks ?? "");
          } else {
            const subjects =
              details?.student_subjects?.length > 0
                ? details.student_subjects
                : details?.subject_details || [];

            subjects.forEach((sub) => {
              formData.append("subject_ids[]", sub.subject_id);
            });

            /*
             * Excel columns:
             *
             * obtained_marks[]
             * obtained_marks[]
             * obtained_marks[]
             *
             * OR:
             *
             * obtained_marks_1
             * obtained_marks_2
             *
             * Support both formats.
             */

            const obtainedMarkKeys = Object.keys(row).filter((key) =>
              key.toLowerCase().startsWith("obtained_marks"),
            );

            obtainedMarkKeys.forEach((key) => {
              formData.append("obtained_marks[]", row[key] ?? "");
            });
          }

          const response = await obtendMarks(formData);

          if (response?.data?.status) {
            console.log(
              `Submitted successfully for registration ${row.registration_no}`,
            );

            return {
              success: true,
              row,
            };
          }

          console.warn(
            `Failed submission for registration ${row.registration_no}:`,
            response?.data?.message,
          );

          return {
            success: false,
            row,
            message: response?.data?.message,
          };
        } catch (error) {
          console.error(
            `Error submitting registration ${row.registration_no}:`,
            error,
          );

          return {
            success: false,
            row,
            error,
          };
        }
      });

      return Promise.all(batchPromises);
    };

    setLoading(true);

    try {
      for (let i = 0; i < totalRecords; i += batchSize) {
        const batchData = dataFromExcel.slice(i, i + batchSize);

        console.log(`Processing batch ${Math.floor(i / batchSize) + 1}`);

        await processBatch(batchData);
      }

      await fetchDetails();

      ToastMain.fire({
        icon: "success",
        title: "Excel marks imported successfully!",
      });
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    formData.append("file", file);

    try {
      const res = await excelimport(formData);
      console.log("Excel import response:", res.data);

      if (res.data) {
        closeModal("statusChange");
        ToastMain.fire({
          icon: "success",
          title: "upload Successfully!",
        });
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: res?.data?.message || "Something Went Wrong!",
        // });
        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDummyDownload = () => {
    let data = [];

    if (details?.exam_mode === "combined") {
      data = [
        ["test_id", "registration_no", "combined_marks"],
        [details.id, "SCAI01", ""],
      ];
    } else {
      data = [
        [
          "test_id",
          "registration_no",
          "obtained_marks[]",
          "obtained_marks[]",
          "obtained_marks[]",
        ],
        ["1", "1029", "70", "70", "70"],
      ];
    }

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Test_Marks_Upload");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(new Blob([excelBuffer]), "Test_Marks_Upload.xlsx");
  };

  const handleDownloadFormat = () => {
    let data = [];

    if (details?.exam_mode === "combined") {
      data = [
        ["test_id", "registration_no", "combined_marks"],
        ["1", "1029", "80"],
      ];
    } else {
      const headers = ["test_id", "registration_no"];

      details.subject_details.forEach((sub) => {
        headers.push("subject_ids[]");
        headers.push("obtained_marks[]");
      });

      const values = ["1", "1029"];

      details.subject_details.forEach((sub) => {
        values.push(sub.subject_id);
        values.push("");
      });

      data = [headers, values];
    }

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Test_Marks_Upload");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Test_Marks_Upload.xlsx");
  };

  const openPrintWindow = (printElement, title = "Marks Report") => {
    const printWindow = window.open(
      "",
      "_blank",
      "width=1400,height=900,scrollbars=yes,resizable=yes",
    );

    if (!printWindow) {
      ToastMain.fire({
        icon: "warning",
        title: "Print window blocked",
        text: "Please allow pop-ups for this website and try again.",
      });

      return;
    }

    const reportHtml = renderToStaticMarkup(printElement);

    /*
     * Copy all CSS files/styles from the current application.
     * This allows TestReportPrint.css and other required styles
     * to work inside the print window.
     */
    const styleLinks = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    )
      .map((link) => {
        const href = link.href;

        if (!href) return "";

        return `<link rel="stylesheet" href="${href}" />`;
      })
      .join("");

    const inlineStyles = Array.from(document.querySelectorAll("style"))
      .map((style) => `<style>${style.innerHTML}</style>`)
      .join("");

    printWindow.document.open();

    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />

        <title>${title}</title>

        ${styleLinks}

        ${inlineStyles}

        <style>
          /* =========================================================
             PRINT WINDOW RESET
             ========================================================= */

          html,
          body {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            min-width: 0 !important;
            min-height: 0 !important;
            height: auto !important;
            background: #ffffff !important;
          }

          body {
            overflow: visible !important;
            font-family: Arial, Helvetica, sans-serif !important;

            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          *,
          *::before,
          *::after {
            box-sizing: border-box !important;
          }

          /* =========================================================
             IMPORTANT:
             Your old CSS uses visibility:hidden for body elements.
             That is NOT required inside this dedicated print window.
             Override it completely.
             ========================================================= */

          body * {
            visibility: visible !important;
          }

          /* =========================================================
             REPORT CONTAINER
             ========================================================= */

          .test-print-report {
            position: static !important;

            display: block !important;

            width: 100% !important;
            max-width: none !important;

            min-width: 0 !important;

            margin: 0 !important;
            padding: 0 !important;

            background: #ffffff !important;

            color: #111827 !important;

            overflow: visible !important;

            box-sizing: border-box !important;
          }

          /* =========================================================
             REMOVE APPLICATION / BOOTSTRAP SPACING
             ========================================================= */

          .container,
          .container-fluid,
          .row,
          [class*="col-"],
          .card,
          .card-body,
          .card-header,
          .card-footer,
          .table-responsive {
            width: auto !important;
            max-width: none !important;

            margin: 0 !important;
            padding: 0 !important;

            border: 0 !important;
            box-shadow: none !important;
          }

          /* =========================================================
             TABLE
             ========================================================= */

          .print-table-wrapper {
            width: 100% !important;

            margin: 4px 0 0 0 !important;
            padding: 0 !important;

            overflow: visible !important;
          }

          .print-marks-table {
            width: 100% !important;
            max-width: none !important;

            margin: 0 !important;
            padding: 0 !important;

            border-collapse: collapse !important;

            table-layout: fixed !important;

            page-break-inside: auto !important;

            break-inside: auto !important;
          }

          .print-marks-table thead {
            display: table-header-group !important;
          }

          .print-marks-table tfoot {
            display: table-footer-group !important;
          }

          .print-marks-table tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }

          /* =========================================================
             PAGE SETTINGS
             ========================================================= */

          @page {
            size: A4 landscape;
            margin: 4mm;
          }

          /* =========================================================
             PRINT
             ========================================================= */

          @media print {

            html,
            body {
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              background: #ffffff !important;
            }

            body {
              overflow: visible !important;
            }

            .test-print-report {
              position: static !important;
              width: 100% !important;

              margin: 0 !important;
              padding: 0 !important;
            }

            .print-report-header,
            .print-subjects,
            .print-ranking-note,
            .print-report-footer {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }

            .print-marks-table {
              width: 100% !important;
            }

            .print-marks-table thead {
              display: table-header-group !important;
            }

            .print-marks-table tr {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
          }
        </style>
      </head>

      <body>
        ${reportHtml}
      </body>
    </html>
  `);

    printWindow.document.close();

    /*
     * Wait for stylesheets/fonts to finish loading before opening
     * the browser print dialog.
     */
    const startPrint = async () => {
      try {
        if (printWindow.document.fonts?.ready) {
          await printWindow.document.fonts.ready;
        }
      } catch (error) {
        console.warn("Font loading skipped:", error);
      }

      setTimeout(() => {
        printWindow.focus();

        printWindow.print();
      }, 300);
    };

    /*
     * Wait until the print window has loaded.
     */
    if (printWindow.document.readyState === "complete") {
      startPrint();
    } else {
      printWindow.onload = startPrint;
    }

    /*
     * Close only after the user finishes/cancels printing.
     */
    printWindow.onafterprint = () => {
      setTimeout(() => {
        printWindow.close();
      }, 100);
    };
  };

  const handlePrint = () => {
    if (!details?.marks?.length) {
      ToastMain.fire({
        icon: "info",
        title: "No student marks available to print",
      });

      return;
    }

    const subjects =
      details?.exam_mode === "combined" ? [] : details?.subject_details || [];

    /*
     * =========================================================
     * SORT FOR PRINT
     *
     * Rank 1
     * Rank 2
     * Rank 3
     * ...
     *
     * Unranked students
     * Absent students
     * =========================================================
     */

    const printMarks = [...details.marks].sort((a, b) => {
      const aAbsent = a?.is_absent === "1";
      const bAbsent = b?.is_absent === "1";

      /*
       * Present students first
       */
      if (aAbsent !== bAbsent) {
        return aAbsent ? 1 : -1;
      }

      const aRank = Number(a?.rank);
      const bRank = Number(b?.rank);

      const aHasRank =
        a?.rank !== null &&
        a?.rank !== undefined &&
        String(a?.rank).trim() !== "" &&
        !Number.isNaN(aRank);

      const bHasRank =
        b?.rank !== null &&
        b?.rank !== undefined &&
        String(b?.rank).trim() !== "" &&
        !Number.isNaN(bRank);

      /*
       * Ranked students before unranked
       */
      if (aHasRank !== bHasRank) {
        return aHasRank ? -1 : 1;
      }

      /*
       * Rank ascending
       */
      if (aHasRank && bHasRank) {
        return aRank - bRank;
      }

      /*
       * Fallback:
       * obtained marks descending
       */
      const aMarks = Number(a?.obtained_total || 0);
      const bMarks = Number(b?.obtained_total || 0);

      return bMarks - aMarks;
    });

    const totalStudents = printMarks.length;

    const presentStudents = printMarks.filter(
      (item) => item?.is_absent !== "1",
    ).length;

    const absentStudents = printMarks.filter(
      (item) => item?.is_absent === "1",
    ).length;

    const rankedStudents = printMarks.filter(
      (item) =>
        item?.is_absent !== "1" &&
        item?.rank !== null &&
        item?.rank !== undefined &&
        String(item?.rank).trim() !== "",
    ).length;

    const printContent = (
      <div className="test-print-report">
        {/* =====================================================
          HEADER
          ===================================================== */}

        <div className="print-report-header">
          <div className="print-header-main">
            <div className="print-title-area">
              <div className="print-report-label">TEST PERFORMANCE REPORT</div>

              <h1>{details?.title || "Test Marks Report"}</h1>

              <div className="print-subtitle">
                Student Academic Performance & Rank Statement
              </div>
            </div>

            <div className="print-status-block">
              <div className="print-status-label">REPORT STATUS</div>

              <div className="print-status">
                {details?.is_marks_locked === "1" ? "FINAL" : "DRAFT"}
              </div>
            </div>
          </div>

          {/* =====================================================
            EXAM INFORMATION
            ===================================================== */}

          <div className="print-info-grid">
            <div className="print-info-item">
              <span>Exam Date</span>
              <strong>{details?.date || "-"}</strong>
            </div>

            <div className="print-info-item">
              <span>Exam Mode</span>

              <strong>
                {details?.exam_mode === "combined"
                  ? "Combined"
                  : "Subject Wise"}
              </strong>
            </div>

            <div className="print-info-item">
              <span>Maximum Marks</span>

              <strong>
                {details?.exam_mode === "combined"
                  ? details?.combined_marks || 0
                  : details?.total_marks || 0}
              </strong>
            </div>

            <div className="print-info-item">
              <span>Total Students</span>
              <strong>{totalStudents}</strong>
            </div>

            <div className="print-info-item">
              <span>Present</span>
              <strong>{presentStudents}</strong>
            </div>

            <div className="print-info-item">
              <span>Absent</span>
              <strong>{absentStudents}</strong>
            </div>

            <div className="print-info-item">
              <span>Ranked</span>
              <strong>{rankedStudents}</strong>
            </div>

            <div className="print-info-item">
              <span>Report Type</span>
              <strong>Marks & Rank</strong>
            </div>
          </div>
        </div>

        {/* =====================================================
          SUBJECT INFORMATION
          ===================================================== */}

        {subjects.length > 0 && (
          <div className="print-subjects">
            <div className="print-section-heading">EXAM STRUCTURE</div>

            <div className="print-subject-list">
              {subjects.map((subject, index) => (
                <div key={index} className="print-subject-item">
                  <span className="print-subject-number">{index + 1}</span>

                  <span className="print-subject-name">
                    {subject?.subject || "-"}
                  </span>

                  <span className="print-subject-marks">
                    {subject?.marks || 0}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* =====================================================
          MARKS TABLE
          ===================================================== */}

        <div className="print-table-wrapper">
          <table className="print-marks-table">
            <thead>
              <tr>
                <th className="serial-col">#</th>

                <th className="student-col">STUDENT</th>

                {details?.exam_mode === "combined" ? (
                  <th className="subject-mark-col">
                    MARKS
                    <span>/ {details?.combined_marks || 0}</span>
                  </th>
                ) : (
                  subjects.map((subject, index) => (
                    <th key={index} className="subject-mark-col">
                      {subject?.subject || "-"}

                      <span>/ {subject?.marks || 0}</span>
                    </th>
                  ))
                )}

                <th className="total-col">TOTAL</th>

                <th className="percentage-col">%</th>

                <th className="rank-col">RANK</th>
              </tr>
            </thead>

            <tbody>
              {printMarks.map((item, index) => {
                const obtainedMarks = getObtainedMarks(item);

                const studentSubjects = getStudentSubjects(item);

                const totalMarks =
                  details?.exam_mode === "combined"
                    ? Number(details?.combined_marks || 0)
                    : Number(item?.total_marks || details?.total_marks || 0);

                const obtainedTotal = Number(item?.obtained_total || 0);

                const percentage = totalMarks
                  ? ((obtainedTotal / totalMarks) * 100).toFixed(1)
                  : "0.0";

                const isAbsent = item?.is_absent === "1";

                const rank =
                  item?.rank !== null &&
                    item?.rank !== undefined &&
                    String(item?.rank).trim() !== ""
                    ? Number(item.rank)
                    : null;

                return (
                  <tr
                    key={item?.id || index}
                    className={isAbsent ? "print-absent-row" : ""}
                  >
                    {/* SERIAL */}

                    <td className="serial-cell">{index + 1}</td>

                    {/* STUDENT */}

                    <td className="print-student">
                      <strong>{item?.student_details?.name || "-"}</strong>

                      <small>
                        Reg. No: {item?.student_details?.registration_no || "-"}
                      </small>
                    </td>

                    {/* SUBJECT MARKS */}

                    {details?.exam_mode === "combined" ? (
                      <td className="marks-cell">
                        {isAbsent
                          ? "ABSENT"
                          : (obtainedMarks[0] ?? item?.obtained_total ?? "-")}
                      </td>
                    ) : (
                      studentSubjects.map((subject, i) => (
                        <td key={i} className="marks-cell">
                          {isAbsent ? "ABSENT" : (obtainedMarks[i] ?? "-")}
                        </td>
                      ))
                    )}

                    {/* TOTAL */}

                    <td className="total-cell">
                      {isAbsent ? (
                        "—"
                      ) : (
                        <>
                          <strong>{obtainedTotal}</strong>

                          <span>/ {totalMarks}</span>
                        </>
                      )}
                    </td>

                    {/* PERCENTAGE */}

                    <td className="percentage-cell">
                      {isAbsent ? "—" : `${percentage}%`}
                    </td>

                    {/* RANK */}

                    <td className="rank-cell">
                      {rank ? (
                        <span className={`print-rank rank-${rank}`}>
                          {rank <= 3 && (
                            <span className="rank-icon">
                              {rank === 1 ? "★" : rank === 2 ? "◆" : "●"}
                            </span>
                          )}

                          {rank}
                        </span>
                      ) : (
                        <span className="no-rank">—</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* =====================================================
          RANKING NOTE
          ===================================================== */}

        {rankedStudents > 0 && (
          <div className="print-ranking-note">
            <strong>Ranking:</strong> Students are arranged in ascending rank
            order, from Rank 1 onwards. Unranked and absent students are listed
            after ranked students.
          </div>
        )}

        {/* =====================================================
          FOOTER
          ===================================================== */}

        <div className="print-report-footer">
          <div>Generated on {new Date().toLocaleDateString("en-IN")}</div>

          <div>{details?.title || "Test Report"}</div>

          <div>Total Students: {totalStudents}</div>
        </div>
      </div>
    );

    /*
     * OPEN DEDICATED PRINT WINDOW
     *
     * No PrintStore
     * No /print route
     * No navigate()
     * No temporary state
     */

    openPrintWindow(
      printContent,
      `${details?.title || "Test Marks Report"} - Marks Report`,
    );
  };

  const handleTimeTablePrint = () => {
    if (!details?.subject_schedule) return;

    const schedule = JSON.parse(details.subject_schedule);

    const printContent = (
      <div className="p-4">
        <h3 className="text-center mb-4">Exam Time Table</h3>

        <table className="table table-bordered text-center align-middle">
          <thead className="table-primary">
            <tr>
              <th>S.No</th>
              <th>Subject</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
            </tr>
          </thead>
          <tbody>
            {schedule.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.subject_name}</td>
                <td>{item.date}</td>
                <td>{item.start_time}</td>
                <td>{item.end_time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );

    openPrintWindow(printContent, "Exam Time Table");
  };

  const filteredMarks = details?.marks?.filter((item) => {
    const keyword = search.trim().toLowerCase();

    if (!keyword) return true;

    return (
      item?.student_details?.name?.toLowerCase().includes(keyword) ||
      item?.student_details?.registration_no?.toLowerCase().includes(keyword) ||
      item?.student_details?.phone?.toLowerCase().includes(keyword)
    );
  });

  const getObtainedMarks = (item) => {
    try {
      return JSON.parse(item?.obtained_marks || "[]");
    } catch {
      return [];
    }
  };

  const getStudentSubjects = (item) =>
    item?.student_subjects?.length > 0
      ? item.student_subjects
      : details?.subject_details || [];

  const getMarksPercentage = (item) => {
    const total =
      details?.exam_mode === "combined"
        ? Number(details?.combined_marks || 0)
        : Number(item?.total_marks || details?.total_marks || 0);

    const obtained = Number(item?.obtained_total || 0);

    if (!total) return 0;

    return Math.min(100, Math.max(0, (obtained / total) * 100));
  };

  const successCount =
    details?.marks?.filter(
      (item) => item?.is_absent !== "1" && Number(item?.obtained_total) > 0,
    ).length || 0;

  const absentCount =
    details?.marks?.filter((item) => item?.is_absent === "1").length || 0;

  const locked = details?.is_marks_locked === "1";

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <TestLayout />
                  <div className="col-12">
                    <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
                      {/* ================= HEADER ================= */}
                      <div className="card-body p-4">
                        <div className="d-flex flex-column flex-xl-row justify-content-between gap-3">
                          <div>
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <span className="badge bg-label-primary rounded-pill px-3 py-2">
                                TEST REPORT
                              </span>

                              {locked ? (
                                <span className="badge bg-label-danger rounded-pill px-3 py-2">
                                  <i className="ri-lock-fill me-1"></i>
                                  Marks Locked
                                </span>
                              ) : (
                                <span className="badge bg-label-success rounded-pill px-3 py-2">
                                  <i className="ri-lock-unlock-fill me-1"></i>
                                  Marks Editable
                                </span>
                              )}
                            </div>

                            <h3 className="fw-bold mb-1">
                              {details?.title || "Test Report"}
                            </h3>

                            <p className="text-muted mb-0">
                              <i className="ri-calendar-line me-2"></i>
                              {details?.date || "Date not available"}
                            </p>
                          </div>

                          {/* ACTIONS */}
                          <div className="d-flex flex-wrap align-items-start gap-2">
                            <Link to={`/tests/view?id=${details?.parent_id}`}>
                              <button className="btn btn-outline-secondary">
                                <i className="ri-arrow-left-line me-1"></i>
                                Back
                              </button>
                            </Link>

                            {hasAccess("/tests/obtained/marks/export") && (
                              <button
                                className="btn btn-outline-success"
                                onClick={handleDownload}
                                title="Export Excel"
                              >
                                <i className="ri-file-excel-2-line me-1"></i>
                                Export
                              </button>
                            )}

                            {hasAccess("/tests/report/print") && (
                              <button
                                className="btn btn-outline-primary"
                                onClick={handlePrint}
                              >
                                <i className="ri-printer-line me-1"></i>
                                Print
                              </button>
                            )}
                            {hasAccess("/tests/maks/import") && (
                              <button
                                className="btn btn-primary"
                                onClick={() => {
                                  const params = new URLSearchParams({
                                    id: details?.id,
                                    exam_mode: details?.exam_mode,
                                    combined_marks: details?.combined_marks || 0,
                                    subjects: JSON.stringify(
                                      details?.subject_details || [],
                                    ),
                                  });

                                  navigate(
                                    `/tests/excel/marks/upload?${params.toString()}`,
                                  );
                                }}
                              >
                                <i className="ri-upload-2-line me-1"></i>
                                Upload Excel
                              </button>
                            )}
                          </div>
                        </div>

                        {/* ================= SUMMARY ================= */}
                        <div className="row g-3 mt-4">
                          <div className="col-6 col-xl-3">
                            <div className="p-3 rounded-3 border h-100">
                              <div className="text-muted small mb-1">
                                <i className="ri-calendar-line me-1"></i>
                                Exam Date
                              </div>
                              <div className="fw-bold fs-6">
                                {details?.date || "-"}
                              </div>
                            </div>
                          </div>

                          <div className="col-6 col-xl-3">
                            <div className="p-3 rounded-3 border h-100">
                              <div className="text-muted small mb-1">
                                <i className="ri-award-line me-1"></i>
                                Total Marks
                              </div>
                              <div className="fw-bold fs-6">
                                {details?.total_marks ||
                                  details?.combined_marks ||
                                  "-"}
                              </div>
                            </div>
                          </div>

                          <div className="col-6 col-xl-3">
                            <div className="p-3 rounded-3 border h-100">
                              <div className="text-muted small mb-1">
                                <i className="ri-group-line me-1"></i>
                                Students
                              </div>
                              <div className="fw-bold fs-6">
                                {details?.marks?.length || 0}
                              </div>
                            </div>
                          </div>

                          <div className="col-6 col-xl-3">
                            <div className="p-3 rounded-3 border h-100">
                              <div className="text-muted small mb-1">
                                <i className="ri-stack-line me-1"></i>
                                Batch
                              </div>
                              <div className="fw-bold fs-6 text-truncate">
                                {details?.batches?.[0]?.title || "-"}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ================= SUBJECTS ================= */}
                        <div className="mt-4">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="fw-bold mb-0">
                              <i className="ri-book-open-line me-2"></i>
                              Exam Structure
                            </h6>

                            {details?.exam_mode === "combined" && (
                              <span className="badge bg-label-info">
                                Combined Exam
                              </span>
                            )}
                          </div>

                          {details?.exam_mode === "combined" ? (
                            <div className="border rounded-3 p-3">
                              <div className="d-flex align-items-center gap-3">
                                <div className="avatar">
                                  <span className="avatar-initial rounded bg-primary">
                                    <i className="ri-calculator-line"></i>
                                  </span>
                                </div>

                                <div>
                                  <div className="fw-semibold">
                                    Combined Marks
                                  </div>
                                  <div className="text-muted small">
                                    Maximum marks:{" "}
                                    {details?.combined_marks || 0}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="row g-2">
                              {details?.subject_details?.map(
                                (subject, index) => (
                                  <div
                                    className="col-12 col-md-6 col-xl-4"
                                    key={index}
                                  >
                                    <div className="border rounded-3 p-3 h-100">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="badge bg-label-primary rounded-circle">
                                            {index + 1}
                                          </span>

                                          <span className="fw-semibold">
                                            {subject?.subject}
                                          </span>
                                        </div>

                                        <span className="badge bg-label-secondary">
                                          {subject?.marks} Marks
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>

                        {/* ================= SCHEDULE ================= */}
                        {details?.subject_schedule && (
                          <div className="mt-4">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="fw-bold mb-0">
                                <i className="ri-time-line me-2"></i>
                                Exam Schedule
                              </h6>

                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={handleTimeTablePrint}
                              >
                                <i className="ri-printer-line me-1"></i>
                                Print Schedule
                              </button>
                            </div>

                            <div className="border rounded-3 overflow-hidden">
                              {JSON.parse(details.subject_schedule).map(
                                (item, index) => (
                                  <div
                                    key={index}
                                    className={`p-3 d-flex flex-column flex-md-row justify-content-between gap-2 ${index !==
                                        JSON.parse(details.subject_schedule)
                                          .length -
                                        1
                                        ? "border-bottom"
                                        : ""
                                      }`}
                                  >
                                    <div className="d-flex gap-3">
                                      <div className="avatar avatar-sm">
                                        <span className="avatar-initial rounded bg-label-primary">
                                          {index + 1}
                                        </span>
                                      </div>

                                      <div>
                                        <div className="fw-semibold">
                                          {item?.subject_name}
                                        </div>

                                        <div className="text-muted small">
                                          <i className="ri-calendar-line me-1"></i>
                                          {item?.date}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="align-self-md-center">
                                      <span className="badge bg-label-success px-3 py-2">
                                        <i className="ri-time-line me-1"></i>
                                        {item?.start_time} - {item?.end_time}
                                      </span>
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="card border-0 shadow-sm rounded-4">
                      {/* ================= STUDENT HEADER ================= */}
                      <div className="card-header bg-transparent border-0 p-4 pb-2">
                        <div className="d-flex flex-column flex-lg-row justify-content-between gap-3">
                          <div>
                            <div className="d-flex align-items-center gap-2">
                              <h5 className="fw-bold mb-0">Students Marks</h5>

                              <span className="badge bg-label-primary rounded-pill">
                                {details?.marks?.length || 0}
                              </span>
                            </div>

                            <p className="text-muted small mb-0 mt-1">
                              Enter marks for each student or use{" "}
                              <strong>A</strong> for absent.
                            </p>
                          </div>

                          {details?.exam_mode !== "combined" &&
                            String(details?.is_marks_locked) == "0" && (
                              <button
                                className="btn btn-outline-danger"
                                onClick={() =>
                                  setShowMissingSubjectsModal(true)
                                }
                              >
                                <i className="ri-error-warning-line me-1"></i>
                                Remove Subjects
                              </button>
                            )}

                          {/* SEARCH */}
                          <div className="test-search-box">
                            <i className="ri-search-line test-search-icon"></i>

                            <input
                              type="text"
                              className="form-control test-search-input"
                              placeholder="Search student or registration no."
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />

                            {search && (
                              <button
                                type="button"
                                className="test-search-clear"
                                onClick={() => setSearch("")}
                                aria-label="Clear search"
                              >
                                <i className="ri-close-line"></i>
                              </button>
                            )}
                          </div>
                        </div>

                        {/* ================= STATISTICS ================= */}
                        <div className="row g-2 mt-3">
                          <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center">
                              <div className="text-muted small">
                                Total Students
                              </div>
                              <div className="fw-bold">
                                {details?.marks?.length || 0}
                              </div>
                            </div>
                          </div>

                          <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center">
                              <div className="text-muted small">Entered</div>
                              <div className="fw-bold text-success">
                                {successCount}
                              </div>
                            </div>
                          </div>

                          <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center">
                              <div className="text-muted small">Absent</div>
                              <div className="fw-bold text-danger">
                                {absentCount}
                              </div>
                            </div>
                          </div>

                          <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center">
                              <div className="text-muted small">Status</div>
                              <div>
                                {locked ? (
                                  <span className="badge bg-danger">
                                    Locked
                                  </span>
                                ) : (
                                  <span className="badge bg-success">
                                    Editable
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ================= TABLE ================= */}
                      <div className="card-body pt-3 px-0">
                        <div
                          className="table-responsive"
                          style={{
                            maxHeight: "calc(100vh - 330px)",
                            overflowY: "auto",
                          }}
                        >
                          <table className="table align-middle mb-0">
                            <thead className="sticky-top" style={{ zIndex: 5 }}>
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "70px" }}
                                >
                                  #
                                </th>

                                <th style={{ minWidth: "230px" }}>Student</th>

                                <th
                                  className="text-center"
                                  style={{ minWidth: "100px" }}
                                >
                                  Rank
                                </th>

                                <th style={{ minWidth: "500px" }}>Marks</th>

                                <th
                                  className="text-center"
                                  style={{ width: "130px" }}
                                >
                                  Result
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {filteredMarks?.length > 0 ? (
                                filteredMarks.map((item, index) => {
                                  const obtainedMarks = getObtainedMarks(item);
                                  const studentSubjects =
                                    getStudentSubjects(item);
                                  const percentage = getMarksPercentage(item);
                                  const isAbsent = item?.is_absent === "1";

                                  return (
                                    <tr key={item?.id || index}>
                                      {/* NUMBER */}
                                      <td className="text-center">
                                        <span className="badge bg-label-secondary rounded-circle">
                                          {index + 1}
                                        </span>
                                      </td>

                                      {/* STUDENT */}
                                      <td>
                                        <div className="d-flex align-items-center gap-3">
                                          <div className="avatar">
                                            <span className="avatar-initial rounded-circle bg-label-primary">
                                              {item?.student_details?.name
                                                ?.charAt(0)
                                                ?.toUpperCase() || "S"}
                                            </span>
                                          </div>

                                          <div>
                                            <div className="fw-semibold">
                                              {item?.student_details?.name ||
                                                "-"}
                                            </div>

                                            <div className="text-muted small">
                                              Reg. No:{" "}
                                              {item?.student_details
                                                ?.registration_no || "-"}
                                            </div>
                                          </div>
                                        </div>
                                      </td>

                                      {/* RANK */}
                                      <td className="text-center">
                                        {item?.rank ? (
                                          <span className="badge bg-label-warning px-3">
                                            <i className="ri-trophy-line me-1"></i>
                                            {item.rank}
                                          </span>
                                        ) : (
                                          <span className="text-muted">-</span>
                                        )}
                                      </td>

                                      {/* MARKS */}
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();

                                            if (!locked) {
                                              TestMarksObtend(e);
                                            }
                                          }}
                                          className="d-flex align-items-end flex-wrap gap-2"
                                        >
                                          <input
                                            type="hidden"
                                            name="test_id"
                                            value={item?.test_id}
                                          />

                                          <input
                                            type="hidden"
                                            name="registration_no"
                                            value={
                                              item?.student_details
                                                ?.registration_no
                                            }
                                          />

                                          {details?.exam_mode === "combined" ? (
                                            <div style={{ width: "150px" }}>
                                              <label className="form-label small fw-semibold mb-1">
                                                Combined
                                                <span className="text-muted">
                                                  {" "}
                                                  / {details?.combined_marks}
                                                </span>
                                              </label>

                                              <input
                                                type="text"
                                                name="combined_marks"
                                                className="form-control"
                                                defaultValue={
                                                  obtainedMarks[0] ??
                                                  item?.obtained_total ??
                                                  ""
                                                }
                                                readOnly={locked}
                                                placeholder="Marks / A"
                                                onChange={(e) => {
                                                  if (locked) return;

                                                  let value =
                                                    e.target.value.toUpperCase();

                                                  if (value === "A") {
                                                    e.target.value = value;
                                                    return;
                                                  }

                                                  if (
                                                    /^\d*\.?\d*$/.test(value)
                                                  ) {
                                                    e.target.value = value;
                                                  } else {
                                                    e.target.value = "";
                                                  }
                                                }}
                                                onBlur={(e) => {
                                                  if (locked) return;

                                                  const value = e.target.value
                                                    .toUpperCase()
                                                    .trim();

                                                  if (
                                                    value === "A" ||
                                                    value === ""
                                                  ) {
                                                    return;
                                                  }

                                                  const marks = Number(value);
                                                  const maxMarks = Number(
                                                    details?.combined_marks,
                                                  );

                                                  if (
                                                    Number.isNaN(marks) ||
                                                    marks < 0 ||
                                                    marks > maxMarks
                                                  ) {
                                                    e.target.value = "";
                                                  }
                                                }}
                                              />
                                            </div>
                                          ) : (
                                            studentSubjects?.map(
                                              (subject, i) => (
                                                <div
                                                  key={i}
                                                  style={{ width: "120px" }}
                                                >
                                                  <input
                                                    type="hidden"
                                                    name="subject_ids[]"
                                                    value={subject?.subject_id}
                                                  />

                                                  <label className="form-label small fw-semibold mb-1 text-truncate d-block">
                                                    {subject?.subject}
                                                    <span className="text-muted">
                                                      {" "}
                                                      / {subject?.marks}
                                                    </span>
                                                  </label>

                                                  <input
                                                    type="text"
                                                    name="obtained_marks[]"
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      obtainedMarks[i] ?? ""
                                                    }
                                                    readOnly={locked}
                                                    placeholder="Marks / A"
                                                    onChange={(e) => {
                                                      if (locked) return;

                                                      let value =
                                                        e.target.value.toUpperCase();

                                                      if (value === "A") return;

                                                      if (
                                                        /^-?\d*\.?\d*$/.test(
                                                          value,
                                                        )
                                                      ) {
                                                        e.target.value = value;
                                                      } else {
                                                        e.target.value = "";
                                                      }
                                                    }}
                                                    onBlur={(e) => {
                                                      const value =
                                                        e.target.value.toUpperCase();

                                                      if (
                                                        value === "A" ||
                                                        value === "" ||
                                                        value === "-"
                                                      ) {
                                                        return;
                                                      }

                                                      const num =
                                                        parseFloat(value);

                                                      if (
                                                        !Number.isNaN(num) &&
                                                        num >=
                                                        -(
                                                          subject?.marks ||
                                                          100
                                                        ) &&
                                                        num <=
                                                        (subject?.marks ||
                                                          100)
                                                      ) {
                                                        e.target.value = num;
                                                      } else {
                                                        e.target.value = "";
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              ),
                                            )
                                          )}

                                          {!locked &&
                                            hasAccess(
                                              "/tests/report/obtained",
                                            ) && (
                                              <button
                                                type="submit"
                                                className="btn btn-primary btn-sm"
                                              >
                                                <i className="ri-check-line me-1"></i>
                                                Save
                                              </button>
                                            )}
                                        </form>
                                      </td>

                                      {/* RESULT */}
                                      <td className="text-center">
                                        {isAbsent ? (
                                          <span className="badge bg-danger-subtle text-danger px-3 py-2">
                                            <i className="ri-user-forbid-line me-1"></i>
                                            Absent
                                          </span>
                                        ) : (
                                          <div>
                                            <div className="fw-bold">
                                              {item?.obtained_total ?? 0}
                                              <span className="text-muted fw-normal">
                                                {" / "}
                                                {item?.total_marks ||
                                                  details?.total_marks ||
                                                  details?.combined_marks ||
                                                  0}
                                              </span>
                                            </div>

                                            <div
                                              className="progress mt-1"
                                              style={{
                                                height: "5px",
                                                width: "90px",
                                                margin: "auto",
                                              }}
                                            >
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${percentage}%`,
                                                }}
                                              ></div>
                                            </div>

                                            <small className="text-muted">
                                              {percentage.toFixed(1)}%
                                            </small>
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center py-5">
                                    <div className="text-muted">
                                      <i className="ri-group-line fs-1 d-block mb-2"></i>

                                      <div className="fw-semibold">
                                        No students found
                                      </div>

                                      <small>
                                        Try changing your search keyword.
                                      </small>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* ================= FOOTER ACTIONS ================= */}
                      <div className="card-footer bg-transparent border-top p-3">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
                          <div className="text-muted small">
                            {locked ? (
                              <>
                                <i className="ri-lock-fill text-danger me-1"></i>
                                Marks are locked and cannot be edited.
                              </>
                            ) : (
                              <>
                                <i className="ri-information-line text-primary me-1"></i>
                                Marks are currently editable.
                              </>
                            )}
                          </div>

                          <div className="d-flex flex-wrap gap-2">
                            {!locked ? (
                              hasAccess("/test/marks/lock") ? (
                                <button
                                  className="btn btn-primary"
                                  onClick={() => TestLocked(details?.id)}
                                >
                                  <i className="bi bi-lock me-1"></i>
                                  Lock Marks
                                </button>
                              ) : null
                            ) : (
                              <>
                                {hasAccess("/test/marks/unlock") ? (
                                  <button
                                    className="btn btn-outline-danger"
                                    onClick={() => TestUnLocked(details?.id)}
                                  >
                                    <i className="bi bi-unlock me-1"></i>
                                    Unlock Marks
                                  </button>
                                ) : null}

                                {hasAccess(
                                  "/tests/report/obtained/message/send",
                                ) && (
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary"
                                      onClick={() =>
                                        TestLockedMessage(details?.id)
                                      }
                                      disabled={loading}
                                    >
                                      {loading ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm me-2"></span>
                                          Sending...
                                        </>
                                      ) : (
                                        <>
                                          <i className="ri-message-3-line me-1"></i>
                                          Send Message
                                        </>
                                      )}
                                    </button>
                                  )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <Footer />
                    <div className="content-backdrop fade"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>

      {showModal && (
        <>
          <div className="modal show fade d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="modal-header">
                    <h5 className="modal-title text-primary">
                      Import test marks via Excel
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>

                  <div className="modal-body">
                    {responseMsg && (
                      <div
                        className={`alert alert-${responseMsg.type === "error" ? "danger" : "success"
                          }`}
                      >
                        {responseMsg.text}
                      </div>
                    )}

                    {/* Download Template */}
                    <div className="mb-3">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handleDummyDownload}
                      >
                        <i className="ri-download-2-line ri-20px"></i>
                        Download Sample Excel
                      </button>
                    </div>

                    {/* Session Select */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        id="fileUpload"
                        type="file"
                        accept=".xlsx, .xls"
                        className="form-control"
                        onChange={handleExcelUpload}
                      />
                      <label htmlFor="fileUpload">Upload Excel File</label>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button type="submit" className="btn btn-success">
                      Upload
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      <div
        className="modal fade"
        id="excelUploadModal"
        tabIndex="-1"
        aria-labelledby="excelUploadModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-xl">
          <div className="modal-content shadow-lg rounded-3">
            {/* HEADER */}
            <div className="modal-header bg-label-primary p-3 text-white d-flex justify-content-between align-items-center rounded-top-3">
              <h5 className="modal-title fw-bold" id="excelUploadModalLabel">
                🧾 Excel Data Preview
              </h5>
              <h5 className="mb-3 text-primary">📤 Upload Excel</h5>
              {/* <button
          type="button"
          className="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button> */}
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="container-fluid">
                <div className="d-flex flex-wrap align-items-center mb-3 gap-2">
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                    className="form-control w-50"
                  />

                  <select
                    value={selectedTest}
                    onChange={(e) => setSelectedTest(e.target.value)}
                    className="form-select w-auto"
                  >
                    <option value="">-- Select Test --</option>
                    {testData?.data && (
                      <option
                        key={testData?.data?.id}
                        value={testData?.data?.id}
                      >
                        {testData?.data.title}
                      </option>
                    )}
                  </select>

                  <select
                    value={delay}
                    onChange={(e) => setDelay(Number(e.target.value))}
                    className="form-select w-auto"
                  >
                    {[...Array(15)].map((_, i) => (
                      <option key={i} value={(i + 1) * 1000}>
                        Delay: {i + 1}s
                      </option>
                    ))}
                  </select>

                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleDownloadFormat}
                  >
                    Dummy Data
                  </button>
                </div>

                {/* Status */}
                <div className="alert border mb-3 p-2 small">
                  ✅ Success: {countStatus("success")} | ❌ Failed:{" "}
                  {countStatus("failed")} | ⏳ Pending: {countStatus("pending")}
                </div>

                {/* Table Section with Scroll */}
                {excelData.length > 0 && (
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    <table className="table table-bordered table-hover align-middle">
                      <thead
                        className="table-primary sticky-top"
                        style={{ zIndex: 5 }}
                      >
                        <tr>
                          <th style={{ width: "50px" }}>#</th>
                          {Object.keys(excelData[0]).map((key, idx) => (
                            <th key={idx}>{key}</th>
                          ))}
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {excelData.map((row, idx) => (
                          <tr key={idx}>
                            <td className="fw-bold">{idx + 1}</td>
                            {Object.keys(row).map((key, i) => (
                              <td key={i}>
                                {statuses[idx] === "failed" ? (
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control form-control-sm ${rowErrors?.[idx]?.[key]
                                          ? "is-invalid"
                                          : ""
                                        }`}
                                      value={row[key]}
                                      onChange={(e) => {
                                        const newData = [...excelData];
                                        newData[idx][key] = e.target.value;
                                        setExcelData(newData);
                                      }}
                                    />
                                    {rowErrors?.[idx]?.[key] && (
                                      <div className="invalid-feedback">
                                        {rowErrors[idx][key][0]}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  row[key]
                                )}
                              </td>
                            ))}
                            <td>
                              {statuses[idx] === "success" && "✅"}
                              {statuses[idx] === "failed" && "❌"}
                              {statuses[idx] === "pending" && "⏳"}
                            </td>
                            <td>
                              {statuses[idx] === "failed" && (
                                <button
                                  className="btn btn-sm btn-outline-info"
                                  onClick={() => handleRepair(idx)}
                                >
                                  Retry
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
              >
                ❌ Cancel
              </button>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-label-primary"
                  onClick={handleUpload}
                  disabled={loading}
                >
                  {loading ? "Uploading..." : "🚀 Start Upload"}
                </button>
                <button
                  className="btn btn-warning"
                  onClick={() => {
                    const firstFailed = statuses.findIndex(
                      (s) => s === "failed",
                    );
                    if (firstFailed !== -1) {
                      setCurrentIndex(firstFailed);
                      handleUpload();
                    }
                  }}
                >
                  🔁 Retry Failed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showMissingSubjectsModal && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow-lg rounded-4">
                {/* HEADER */}
                <div className="modal-header border-0">
                  <div>
                    <h5 className="modal-title fw-bold">
                      <i className="ri-error-warning-line text-danger me-2"></i>
                      Missing Subject Marks
                    </h5>

                    <small className="text-muted">
                      Subjects for which marks have not been uploaded for any
                      student.{" "}
                    </small>
                  </div>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowMissingSubjectsModal(false)}
                  ></button>
                </div>

                {/* BODY */}
                <div className="modal-body pt-2">
                  {getMissingSubjects().length > 0 ? (
                    <>
                      <div className="alert alert-danger d-flex align-items-center gap-2">
                        <i className="ri-alert-line fs-5"></i>

                        <div>
                          <strong>{getMissingSubjects().length}</strong>{" "}
                          subject(s) do not have marks uploaded for any student
                          yet.
                        </div>
                      </div>

                      <div className="list-group">
                        {getMissingSubjects().map((subject, index) => {
                          const subjectId = String(subject?.subject_id);
                          const selected =
                            selectedRemoveSubjects.includes(subjectId);

                          return (
                            <div
                              key={subjectId}
                              className={`list-group-item d-flex justify-content-between align-items-center ${selected ? "bg-light-danger" : ""
                                }`}
                            >
                              <div className="d-flex align-items-center gap-3">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selected}
                                  onChange={() =>
                                    toggleRemoveSubject(subject?.subject_id)
                                  }
                                />

                                <div className="avatar avatar-sm">
                                  <span className="avatar-initial rounded-circle bg-label-danger">
                                    {index + 1}
                                  </span>
                                </div>

                                <div>
                                  <div className="fw-semibold">
                                    {subject?.subject || "Unknown Subject"}
                                  </div>

                                  <small className="text-muted">
                                    Subject ID: {subject?.subject_id}
                                  </small>
                                </div>
                              </div>

                              <span className="badge bg-danger">No Marks</span>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-4">
                      <div className="mb-3">
                        <i
                          className="ri-checkbox-circle-line text-success"
                          style={{ fontSize: "60px" }}
                        ></i>
                      </div>

                      <h5 className="fw-bold">All Subjects Have Marks </h5>

                      <p className="text-muted mb-0">
                        Marks have been uploaded for at least one student in
                        every subject.
                      </p>
                    </div>
                  )}
                </div>

                {/* FOOTER */}
                <div className="modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setSelectedRemoveSubjects([]);
                      setShowMissingSubjectsModal(false);
                    }}
                  >
                    Close
                  </button>

                  {selectedRemoveSubjects.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleRemoveSubjects}
                      disabled={removingSubjects}
                    >
                      {removingSubjects ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Removing...
                        </>
                      ) : (
                        <>
                          <i className="ri-delete-bin-line me-1"></i>
                          Remove Selected ({selectedRemoveSubjects.length})
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal-backdrop fade show"
            onClick={() => setShowMissingSubjectsModal(false)}
          ></div>
        </>
      )}
    </>
  );
}
